<template>
    <section class="users">
        <div class="p-t-md">
            <b-tabs v-model="activeTab">
                <b-tab-item label="Users" value="users">
                    <div class="level">
                        <div class="level-item level-right">
                            <b-checkbox v-model="withTrashed" :native-value="true">Show Deleted User</b-checkbox>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="card m-t-md">
                                <div class="card-content">
                                    <b-table :data="users" :loading="loading">
                                        <template slot-scope="props">
                                            <b-table-column
                                                field="id"
                                                label="ID"
                                            >
                                                <a href="#" @click.stop.prevent="goToUser(props.row.id)">
                                                    {{ props.row.id | makeIDSixDigits }}
                                                </a>
                                            </b-table-column>

                                            <b-table-column
                                                field="name"
                                                label="Name"
                                                >{{ props.row.attributes.name }}
                                            </b-table-column>

                                            <b-table-column label="Super Admin" centered v-if="isRole('superadmin')">
                                                <b-switch
                                                    @input="updateRole(props.row, 'superadmin', isHaveRole(props.row, 1))"
                                                    :native-value="isHaveRole(props.row, 1)"
                                                    :value="isHaveRole(props.row, 1)"
                                                    type="is-info"
                                                ></b-switch>
                                            </b-table-column>

                                            <b-table-column label="Gate Keeper" centered>
                                                <b-switch
                                                    @input="updateRole(props.row, 'gatekeeper', isHaveRole(props.row, 2))"
                                                    :native-value="isHaveRole(props.row, 2)"
                                                    :value="isHaveRole(props.row, 2)"
                                                    type="is-info"
                                                ></b-switch>
                                            </b-table-column>

                                            <b-table-column label="Service Person" centered v-if="isRole('superadmin')">
                                                <b-switch
                                                    @input="updateRole(props.row, 'serviceperson', isHaveRole(props.row, 3))"
                                                    :native-value="isHaveRole(props.row, 3)"
                                                    :value="isHaveRole(props.row, 3)"
                                                    type="is-info"
                                                ></b-switch>
                                            </b-table-column>

                                            <b-table-column label="Developer" centered v-if="isRole('superadmin')">
                                                <b-switch
                                                    @input="updateRole(props.row, 'developer', isHaveRole(props.row, 4))"
                                                    :native-value="isHaveRole(props.row, 4)"
                                                    :value="isHaveRole(props.row, 4)"
                                                    type="is-info"
                                                ></b-switch>
                                            </b-table-column>

                                            <b-table-column label="Manage Tickets" centered v-if="isRole('superadmin')">
                                                <b-switch
                                                    @input="updatePermission(props.row, 2)"
                                                    :native-value="isHavePermission(props.row, 2)"
                                                    :value="isHavePermission(props.row, 2)"
                                                    type="is-info"
                                                ></b-switch>
                                            </b-table-column>

                                            <b-table-column label="Manage Releases" centered v-if="isRole('superadmin')">
                                                <b-switch
                                                    @input="updatePermission(props.row, 1)"
                                                    :native-value="isHavePermission(props.row, 1)"
                                                    type="is-info"
                                                ></b-switch>
                                            </b-table-column>

                                            <b-table-column label="View Status" centered v-if="isRole('superadmin')">
                                                <b-switch
                                                    @input="updatePermission(props.row, 4)"
                                                    :native-value="isHavePermission(props.row, 4)"
                                                    :value="isHavePermission(props.row, 4)"
                                                    type="is-info"
                                                ></b-switch>
                                            </b-table-column>

                                            <b-table-column centered v-if="!isRole('superadmin')">
                                                <b-button type="is-danger" size="is-small" disabled v-if="props.row.attributes.deleted_at">DELETED</b-button>
                                            </b-table-column>

                                            <b-table-column label="Action" centered v-if="isRole('superadmin')">
                                                <b-button type="is-danger" size="is-small" @click="deleteUser(props.row)" v-if="!props.row.attributes.deleted_at">Delete</b-button>
                                                <b-button type="is-info" size="is-small" @click="restoreUser(props.row)" v-else>Restore</b-button>
                                            </b-table-column>

                                        </template>

                                        <!-- If Empty -->
                                        <template slot="empty">
                                            <section class="section">
                                                <div class="content has-text-grey has-text-centered">
                                                    <p>
                                                        <b-icon icon="alert-decagram-outline" size="is-large"></b-icon>
                                                    </p>
                                                    <p>NO RESULTS FOUND</p>
                                                </div>
                                            </section>
                                        </template>
                                    </b-table>
                                    <hr>
                                    <b-pagination
                                        v-if="pagination.total >= 100"
                                        :total="pagination.total"
                                        :current.sync="pagination.currentPage"
                                        :order="pagination.order"
                                        :size="pagination.size"
                                        :simple="false"
                                        :rounded="false"
                                        :per-page="pagination.perPage"
                                    ></b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab-item>
                <b-tab-item label="Domains" value="domains">
                    <domain></domain>
                </b-tab-item>
            </b-tabs>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import domain from "./domain.vue";
export default {
    components:{
        domain
    },
    data() {
        return {
            loading: false,
            users: [],
            rolesPermission: [],
            pagination: {
                total: 0,
                currentPage: 1,
                perPage: 0,
                order: "default",
                size: "default"
            },
            activeTab:"users",
            withTrashed:null
        };
    },
    watch: {
        "pagination.currentPage"(value) {
            this.loading = true;
            this.getUsers(value);
        },
        withTrashed(){
            this.getUsers(1)
        }
    },
    mounted() {
        this.loading = true;
        this.getUsers(1);
        this.activeTab = this.$router.currentRoute.query.tabSelected ? this.$router.currentRoute.query.tabSelected : null
    },
    beforeDestroy() {
        this.$store.commit("SET_SUCCESS_MESSAGE", null);
        this.$store.commit("SET_ERRORS", null);
    },
    methods: {
        goToUser(id) {
            this.$router.push({ name: 'users.edit', params: { id } });
        },
        getUsers(page) {
            let params = `?page=${page ? page : 1}&includes=permissions`;
            if(this.withTrashed){
                params+='&trashed=true'
            }
            Vue.$userService.userList(params).then(response => {
                this.users = response.data;
                this.rolesPermission = response.included;
                this.pagination.total = response.meta.pagination.total;
                this.pagination.currentPage =
                    response.meta.pagination.current_page;
                this.pagination.perPage = response.meta.pagination.per_page;
                this.loading = false;
            })
        },
        async updateRole(user, role, isRoleExist) {
            this.loading = true;
            let data = [];
            if (!isRoleExist) {
                data = { addRole: role };
            } else {
                data = { removeRole: role };
            }
            this.updatedUser(user.id, data);
        },
        isHaveRole(user, roleId) {
            let results = user.relationships.roles.data.filter(
                role => role.type == "roles" && role.id == roleId
            );
            if (results.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        isHavePermission(user, permissionId) {
            let results = user.relationships.permissions.data.filter(
                permissions =>
                    permissions.type == "permissions" &&
                    permissions.id == permissionId
            );
            if (results.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        updatePermission(user, permissionId) {
            let results = user.relationships.permissions.data.filter(
                permissions =>
                    permissions.type == "permissions" &&
                    permissions.id == permissionId
            );
            let data = [];
            if (results.length > 0) {
                data = { removePermission: permissionId };
            } else {
                data = { addPermission: permissionId };
            }
            this.updatedUser(user.id, data);
        },
        updatedUser(id, data) {
            this.loading = true;
            Vue.$userService.updateUser(id, data).then(() => {
                this.getUsers();
                this.loading = false;
            });
        },
        deleteUser(user){
            this.$buefy.dialog.confirm({
                type:'is-danger',
                title:'Are you sure?',
                message:'Are you sure you want to delete this user?',
                onConfirm:()=>{
                    return Vue.$userService.deleteUser(user.id).then(()=>{
                        this.$buefy.toast.open({
                            type:'is-success',
                            message:'User deleted!'
                        })
                        this.getUsers(1);
                    })
                }
            })
        },
        restoreUser(user){
            this.$buefy.dialog.confirm({
                type:'is-success',
                title:'Are you sure?',
                message:'Are you sure you want to restore this user?',
                onConfirm:()=>{
                    return Vue.$userService.restoreUser(user.id).then(()=>{
                        this.$buefy.toast.open({
                            type:'is-success',
                            message:'User restored!'
                        })
                        this.getUsers(1);
                    })
                }
            })
        }
    }
};
</script>